export default "__VITE_ASSET__BF2snL2s__"